/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"

// React
import React, { useEffect, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useParams } from "react-router-dom"

import Spinner from "../../../components/Spinner"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { AppDispatch } from "../../.."
import { useDispatch } from "react-redux"

import AyanasQueryService from "../../../service/ayanasQuery/ayanasQueryService"
import { TAyanasQueryRes } from "../../../service/ayanasQuery/TAyanasQuery"
import dayjs from "dayjs"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../../constant"
import { eフィールド型区分 } from "../../../constant/enum/ayanasQuery"

/**
 * ユーザマスタ
 * @return React.FC
 */
const QueryResult: React.FC<{ tabIndex: number }> = (props) => {
  const { queryId: id } = useParams<{ queryId: string }>()

  let gridId = "AyanasQueryTop_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: any[], pageSize: number) => {
    return new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        const pageIndex = flexGrid!.itemsSource!.pageIndex
        setPageNumber(pageIndex)
      },
    })
  }
  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async () => {
    setSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    // APIより値を取得する
    // sessionの作成
    const service = new AyanasQueryService()
    try {
      const res = await service.getRunResult(id)

      dispatch(setAlerts(res))

      // 検索結果をstateにセット
      setクエリ名称(res.data.クエリ情報.クエリ名称)
      //columnLayoutを利用してgridのcolumnを定義
      setGridColumnLayout(res.data.クエリ情報)
      setGridData({
        data: createCollectionView(res.data.実行結果リスト, pageSize),
      })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setSearching(false)
    }
  }
  const toDataType = (フィールド型区分コード: string) => {
    switch (フィールド型区分コード) {
      case "1":
        return "String"
      case "2":
        return "Number"
      case "3":
      case "4":
        return "Date"
      default:
        return "String"
    }
  }
  const toFieldFormat = (フィールド型区分コード: string) => {
    const フィールドフォーマット: { [name: string]: string } = {
      [eフィールド型区分.Number]: "n0",
      [eフィールド型区分.Date]: "yyyy/MM/dd",
      [eフィールド型区分.Datetime]: "yyyy/MM/dd HH:mm:ss",
    }
    return フィールドフォーマット[フィールド型区分コード] ?? ""
  }

  const toCellTemplate = (フィールド型区分コード: string) => {
    switch (フィールド型区分コード) {
      case "2":
        return null
      case "3":
        return (ctx: wjGrid.ICellTemplateContext) => {
          if (ctx.value == null || wjCore.isNullOrWhiteSpace(ctx.value))
            return ""
          return dayjs(ctx.value).format("YYYY/MM/DD")
        }
      case "4":
        return (ctx: wjGrid.ICellTemplateContext) => {
          if (ctx.value == null || wjCore.isNullOrWhiteSpace(ctx.value))
            return ""
          return dayjs(ctx.value).format("YYYY/MM/DD HH:mm:ss")
        }
      default:
        return null
    }
  }
  const setGridColumnLayout = (クエリ情報: TAyanasQueryRes) => {
    if (flexGrid == null) return
    const newColumnLayout = {
      columns: [
        ...クエリ情報.フィールドリスト.map((フィールド) => ({
          binding: フィールド.フィールド物理名.toLowerCase(),
          header: フィールド.フィールド論理名,
          dataType: toDataType(フィールド.フィールド型区分コード),
          format: toFieldFormat(フィールド.フィールド型区分コード),
        })),
      ],
    }
    flexGrid.columnLayout = JSON.stringify(newColumnLayout)

    クエリ情報.フィールドリスト.forEach((フィールド) => {
      const column = flexGrid.columns.find(
        (column) => column.binding === フィールド.フィールド物理名.toLowerCase()
      )
      if (column != null)
        column.cellTemplate = toCellTemplate(フィールド.フィールド型区分コード)
    })
  }

  const loadedRows = (s: wjGrid.FlexGrid) => {
    s.autoSizeColumns()
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  // グリッド初期化フラグ
  const [flexGridInitialized, setFlexGridInitialized] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()

  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [searching, setSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [state]

  // 検索条件用
  const [クエリ名称, setクエリ名称] = useState<string>("")

  //#endregion

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    setFlexGrid(grid)
  }

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    if (flexGridInitialized && props.tabIndex === 1) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (id != null) {
        // 再検索
        search()
      }
    }
  }, [flexGridInitialized, props.tabIndex])

  //#endregion

  return (
    <Container fluid>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            <Card.Body id="searchConditionCardInner">
              <form>
                <Container className="search-condition-form" fluid>
                  <Row>
                    <Col>
                      <Container className="info-form" fluid>
                        <div className="info-form-row">
                          {/* クエリ名 text */}
                          <div className="info-form-item">
                            <div className="info-form-label w-10rem">
                              <label htmlFor="クエリ名">クエリ名</label>
                            </div>
                            <div className="info-form-value w-40rem">
                              {クエリ名称}
                            </div>
                          </div>
                        </div>
                      </Container>
                    </Col>
                    {/* 検索ボタン */}
                    <Col className="form-button text-right">
                      <Button
                        type="submit"
                        disabled={searching}
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          search()
                        }}>
                        検索
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={searching}></Spinner>
            <Card.Body>
              <span>
                Shiftキーを押しながら見出しをクリックするとソート順を追加できます。Ctrlを押しながら見出しをクリックするとソート順を外します。
              </span>
              {/* itemSourceに検索済み想定のGridData設定 */}
              <Row className="grid-content-row">
                <Col className="grid-content">
                  <FlexGridOuter
                    flexGrid={flexGrid}
                    setFlexGrid={setFlexGrid}
                    gridConstantProperties={
                      CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                    }
                    gridData={gridData}
                    setGridData={setGridData}
                    pageNumber={pageNumber}
                    gridId={gridId}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={flexGridInitialized}
                    setGridInitialized={setFlexGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    gridInitializedHandler={gridInitializedHandler}
                    gridProperties={{
                      autoGenerateColumns: false,
                      loadedRows,
                    }}></FlexGridOuter>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default QueryResult
